import React from "react";
import { RemocalWidget, shouldShowRemocalWidget } from "@jsq/common-components";
import { RichEmptyState } from "@jsq/ds/core";
import { missingPermissionWrapper, emptyState } from "./styles_vanilla.css";

/**
 * An empty state that is shown if the user does not have admin permission on the admin arena
 */
export const MissingPermissionState: React.FC = () => {
  return (
    <div className={missingPermissionWrapper}>
      {shouldShowRemocalWidget() && <RemocalWidget />}
      <RichEmptyState
        className={emptyState}
        description={<>You do not have permission to access this page.</>}
        illustration="searching"
        title="Permissions Missing"
      />
    </div>
  );
};
